import { format, unwrapFunctionStore } from 'svelte-i18n';

import { studioSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const savingSignature = {
  element:
    '#signature-editor > div.page-header > div > div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > button.btn.btn-primary',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.SAVE.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.SAVE.DESCRIPTION'),
    onNextClick: () => {
      const studioButton = document.querySelector(
        '#signature-editor > div.page-header > div > div:nth-child(1) > div > nav > ol > li:nth-child(2) > a'
      );

      studioSettingsStore.subscribe((studio) => {
        studio.tours.editHasToured = true;
      })();

      if (studioButton) {
        studioButton.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
